export  type IWork = {
  _id?: string;
  name: string;
  category: string;
  maximumApplication?: number;
  preventive: boolean;
  corrective: boolean;
  misuse: boolean;
  sellPrice: number;
}

export const emptyWork = (): IWork => ({
  name: "",
  category: "",
  preventive: false,
  corrective: false,
  misuse: false,
  sellPrice: 0
});